<template>
  <div class="pureTextcrossInner" v-if="screenType == '0'">
    <div class="title">{{ data.title }}</div>
    <div class="content" v-html="data.content"></div>
  </div>
  <div class="pureTextverticalInner" v-else>
    <div class="title">{{ data.title }}</div>
    <div class="content" v-html="data.content"></div>
  </div>
</template>

<script>
export default {
  name: "pureTextCampusDynamic",
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    screenType: {
      type: String,
      default: "1",
    },
  },
  created() {},
  methods: {},
};
</script>

<style>
</style>